import { render, staticRenderFns } from "./ProductideaCard.vue?vue&type=template&id=f94ef716&"
import script from "./ProductideaCard.vue?vue&type=script&lang=js&"
export * from "./ProductideaCard.vue?vue&type=script&lang=js&"
import style0 from "./ProductideaCard.vue?vue&type=style&index=0&id=f94ef716&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports